
import { Component, Vue } from "vue-property-decorator";
import Bus from "@/lib/Bus"
const bus: Bus = new Bus().getBus();

import AIFolderVue from "./ai/AIFolderVue.vue";
import { IUser } from "server/src/user/IUser";
import ContextVue from "./ai/ContextVue.vue"
Vue.component('ai-folder-vue', AIFolderVue);
Vue.component('context-vue', ContextVue);

@Component({components: {AIFolderVue } })
export default class AiComponent extends Vue {

  show_ai: boolean = false

  key=0
  async mounted() {
    const user:IUser=bus.get_user();
    this.show_ai=false;
   
    if (user.data_username=="JACEK MALCZEWSKI") {
        this.show_ai=true;
    }
    if (user.data_username=="PAULINA ŁUKOWICZ") {
        this.show_ai=true;
    }
    if (user.data_username=="ŁUKASZ TOMASZEWSKI") {
        this.show_ai=true;
    }

    this.key++
  }
  
}
